export default {
  SET_ALL_TRACKED_ROUTES (state, payload) {
    state.allTrackedRoutes = payload
  },
  SET_SHOW_TRACK (state, bool) {
    state.showTrack = bool
  }
}
